import { RouterModule, Routes } from '@angular/router'
import { NgModule } from '@angular/core'

import { RiskScorecardConfigDetailComponent } from '@modules/private/risk-scorecard-config/components/risk-scorecard-config-detail/risk-scorecard-config-detail.component'
import { RiskScorecardConfigListComponent } from '@modules/private/risk-scorecard-config/components/risk-scorecard-config-list/risk-scorecard-config-list.component'
import { AlgorithmConfigDetailComponent } from './modules/private/algorithm-config/components/algorithm-config-detail/algorithm-config-detail.component'
import { AlgorithmConfigListComponent } from './modules/private/algorithm-config/components/algorithm-config-list/algorithm-config-list.component'
import { RoadmapProjectShowcaseComponent } from '@modules/private/roadmap/components/roadmap-project-showcase/roadmap-project-showcase.component'
import { QuoteParametersPreviewComponent } from '@modules/private/quote/components/quote-parameters-preview/quote-parameters-preview.component'
import { WalletConfigDetailComponent } from '@modules/private/wallet-config/components/wallet-config-detail/wallet-config-detail.component'
import { DocumentationProgressComponent } from '@modules/private/documentation/documentation-progress/documentation-progress.component'
import { PreofferReviewDetailComponent } from '@modules/private/preoffer/views/preoffer-review-detail/preoffer-review-detail.component'
import { WalletConfigListComponent } from '@modules/private/wallet-config/components/wallet-config-list/wallet-config-list.component'
import { CreditValidationDetailComponent } from '@modules/private/credit-history/views/validation-detail/validation-detail.component'
import { PreofferReviewsListComponent } from '@modules/private/preoffer/views/preoffer-reviews-list/preoffer-reviews-list.component'
import { CreditValidationsListComponent } from '@modules/private/credit-history/views/validations-list/validations-list.component'
import { DocumentationViewerComponent } from '@modules/private/documentation/documentation-viewer/documentation-viewer.component'
import { OmnichannelMetricsComponent } from '@modules/private/omnichannel/omnichannel-metrics/omnichannel-metrics.component'
import { InvoiceRulesListComponent } from '@modules/private/invoice-rules/invoice-rules-list/invoice-rules-list.component'
import { PreofferSettingsComponent } from '@modules/private/preoffer/views/preoffer-settings/preoffer-settings.component'
import { CommunicationsListComponent } from '@modules/private/dripping/communications-list/communications-list.component'
import { ProviderDetailComponent } from '@modules/private/provider/components/provider-detail/provider-detail.component'
import { StrategyWizardComponent } from '@modules/private/dripping/components/strategy-wizard/strategy-wizard.component'
import { CampaignDetailComponent } from '@modules/private/dripping/components/campaign-detail/campaign-detail.component'
import { CommitteeLeasesComponent } from '@modules/private/committee/views/committee-leases/committee-leases.component'
import { OmnichannelAdminComponent } from '@modules/private/omnichannel/omnichannel-admin/omnichannel-admin.component'
import { WalletsDetailComponent } from '@modules/private/wallet/components/wallets-detail/wallets-detail.component'
import { DOCUMENTATION_MENU } from '@modules/private/documentation/data/constants/documentation-catalog.constant'
import { SessionDetailComponent } from '@modules/private/committee/views/session-detail/session-detail.component'
import { AdminDetailsComponent } from '@modules/private/wallet/components/admin-details/admin-details.component'
import { CommitteesPageComponent } from '@modules/private/committee/committees-page/committees-page.component'
import { SessionsListComponent } from '@modules/private/committee/views/sessions-list/sessions-list.component'
import { CustomerDetailComponent } from '@modules/private/customer/customer-detail/customer-detail.component'
import { TemplateDetailComponent } from '@modules/private/dripping/template-detail/template-detail.component'
import { StrategiesListComponent } from '@modules/private/dripping/strategies-list/strategies-list.component'
import { StrategyDetailComponent } from '@modules/private/dripping/strategy-detail/strategy-detail.component'
import { QuoteDetailComponent } from '@modules/private/quote/components/quote-detail/quote-detail.component'
import { ConciliacionComponent } from '@modules/private/cobranza/views/conciliacion/conciliacion.component'
// Dripping Components
import { TemplatesListComponent } from '@modules/private/dripping/templates-list/templates-list.component'
import { CampaignsListComponent } from '@modules/private/dripping/campaigns-list/campaigns-list.component'
import { CustomerListComponent } from '@modules/private/customer/customer-list/customer-list.component'
import { ProviderListComponent } from '@modules/private/provider/provider-list/provider-list.component'
import { CobranzaPageComponent } from '@modules/private/cobranza/cobranza-page/cobranza-page.component'
import { FunnelTasksComponent } from '@modules/private/omnichannel/funnel-tasks/funnel-tasks.component'
import { HomeDashboardComponent } from '@modules/private/home/home-dashboard/home-dashboard.component'
import { ActiveDetailComponent } from '@modules/private/active/active-detail/active-detail.component'
import { PaymentListComponent } from '@modules/private/payment/payment-list/payment-list.component'
import { RoadmapPageComponent } from '@modules/private/roadmap/roadmap-page/roadmap-page.component'
import { ChangePasswordComponent } from '@modules/public/change-password/change-password.component'
import { LeaseDetailComponent } from '@modules/private/lease/lease-detail/lease-detail.component'
import { WalletListComponent } from '@modules/private/wallet/wallet-list/wallet-list.component'
import { ActiveListComponent } from '@modules/private/active/active-list/active-list.component'
import { ReporteriaComponent } from '@modules/private/reports/reporteria/reporteria.component'
import { CentralComponent } from '@modules/private/cobranza/views/central/central.component'
import { CarteraComponent } from '@modules/private/cobranza/views/cartera/cartera.component'
import { QuoteListComponent } from '@modules/private/quote/quote-list/quote-list.component'
import { LeaseListComponent } from '@modules/private/lease/lease-list/lease-list.component'
import { AdminListComponent } from '@modules/private/admin/admin-list/admin-list.component'
import { AvanceComponent } from '@modules/private/cobranza/views/avance/avance.component'
import { InvoicesComponent } from '@modules/private/invoices/invoices.component'
import { LogoutComponent } from '@modules/private/logout/logout.component'
import { QuoterComponent } from '@modules/public/quoter/quoter.component'
import { LoginComponent } from '@modules/public/login/login.component'
import { abrirCargaDePagos } from '@app/abrir-carga-de-pagos.guard'
import { NoAuthGuard } from '@app/no-auth.guard'
import { AuthGuard } from '@app/auth.guard'

//* Exportado para que la bitácora pueda cruzarlo contra SCREEN_LABELS en una prueba: sin ese
//* guardarraíl, el mapa de nombres de pantalla nace viejo en la siguiente ruta que alguien agregue.
export const routes: Routes = [
  {
    path: '',
    component: HomeDashboardComponent,
    canActivate: [AuthGuard],
    data: { module: 'dashboard', permission: 'view' },
  },
  {
    path: 'active',
    data: { module: 'assets', permission: 'view' },
    children: [
      {
        path: '',
        component: ActiveListComponent,
        canActivate: [AuthGuard],
        data: { module: 'assets', permission: 'view' },
      },
      {
        path: ':id',
        component: ActiveDetailComponent,
        canActivate: [AuthGuard],
        data: { module: 'assets', permission: 'get-by-id' },
      },
    ],
  },
  {
    path: 'customer',
    data: { module: 'clients', permission: 'view' },
    children: [
      {
        path: '',
        component: CustomerListComponent,
        canActivate: [AuthGuard],
        data: { module: 'clients', permission: 'view' },
      },
      {
        path: ':id',
        component: CustomerDetailComponent,
        canActivate: [AuthGuard],
        data: { module: 'clients', permission: 'get-by-id' },
      },
    ],
  },
  {
    path: 'quote',
    data: { module: 'quotations', permission: 'view' },
    children: [
      {
        path: '',
        component: QuoteListComponent,
        canActivate: [AuthGuard],
        data: { module: 'quotations', permission: 'view' },
      },
      {
        path: 'parameters/:id',
        component: QuoteParametersPreviewComponent,
        canActivate: [AuthGuard],
        data: { module: 'quotations', permission: 'get-by-id' },
      },
      {
        path: ':id',
        component: QuoteDetailComponent,
        canActivate: [AuthGuard],
        data: { module: 'quotations', permission: 'get-by-id' },
      },
    ],
  },
  {
    path: 'lease',
    data: { module: 'leases', permission: 'view' },
    children: [
      {
        path: '',
        component: LeaseListComponent,
        canActivate: [AuthGuard],
        data: { module: 'leases', permission: 'view' },
      },
      {
        //* `leases.view` (no `get-by-id`): el menú y la lista ya exigen `view`, y Broker/
        //* MasterBroker (que tienen get-by-id pero NO view) podían abrir el detalle por URL
        //* directa — sin entrada de menú y cosechando 403 de pestañas que no les tocan.
        path: ':id',
        component: LeaseDetailComponent,
        canActivate: [AuthGuard],
        data: { module: 'leases', permission: 'view' },
      },
    ],
  },
  /**
   * Cobranza: una pantalla, y **la vista en la RUTA**.
   *
   * Antes la pestaña era estado en memoria, así que la barra de direcciones y el resaltado del menú
   * se despegaban de lo que se veía —se llegaba a ver `/application` mostrando comprobantes con
   * «Aplicaciones» resaltado—, no se podía guardar una vista en marcadores y «atrás» no deshacía un
   * cambio de pestaña.
   *
   * **El padre es un CASCARÓN con su propio componente y los hijos van dentro de su outlet.** Antes
   * los tres hijos montaban el MISMO componente, así que cambiar de vista lo destruía y lo recreaba
   * entero: el encabezado, el embudo y las fichas volvían a montarse y a pedir sus datos para acabar
   * enseñando exactamente lo mismo. Ahora solo se cambia el cuerpo.
   *
   * El padre **no lleva `canActivate`** a propósito: quien tenga `invoices.view` pero no
   * `payments.view` tiene que poder abrir Comprobantes. Gatean los hijos, cada uno con **su propio
   * par `module`/`permission`** — el arreglo estructural del B-04. `data` va COMPLETO en cada hijo y
   * no solo en el padre: con la estrategia por defecto un hijo con path no vacío no hereda nada, y
   * `AuthGuard` deja pasar cuando le faltan `module` o `permission`.
   */
  {
    path: 'cobranza',
    component: CobranzaPageComponent,
    data: { module: 'payments', permission: 'view' },
    children: [
      { path: '', redirectTo: 'dinero', pathMatch: 'full' },
      {
        path: 'dinero',
        component: PaymentListComponent,
        canActivate: [AuthGuard],
        data: { module: 'payments', permission: 'view', view: 'dinero', lens: 'todos' },
      },
      {
        path: 'comprobantes',
        component: InvoicesComponent,
        canActivate: [AuthGuard],
        data: { module: 'invoices', permission: 'view', view: 'comprobantes' },
      },
      {
        //* La cola de excepciones exige `adjust`, no `view`: desde aquí se anula y se condona dinero.
        //* Con las tres puertas viejas esto no se podía expresar — una ruta, un solo par.
        path: 'por-atender',
        component: PaymentListComponent,
        canActivate: [AuthGuard],
        data: { module: 'payments', permission: 'adjust', view: 'atender', lens: 'atender' },
      },
      /**
       * El asistente de carga ya NO es una ruta: vive en un modal de Cobranza y se enciende con
       * `?carga=nuevo` o `?carga=<uploadBatch>`. Cargar los pagos del día es una tarea DE esta
       * pantalla, no un destino al que salir.
       *
       * Sus dos direcciones viejas se conservan, porque son las que el operador pudo guardar cuando
       * dejó un lote a medias. Van por guarda y no por `redirectTo` porque hay que escribir un
       * parámetro de consulta, y `redirectTo` solo sabe de rutas. Gate `payments.create` y no `view`:
       * aquí se crean pagos y se aplican.
       */
      {
        //* CENTRAL es de FACTURAS, no de pagos: su par es `invoices`/`get-all`, el mismo que abre el
        //* endpoint. Ponerle `payments` la habría dejado abierta a quien no puede ver una factura.
        path: 'central',
        component: CentralComponent,
        canActivate: [AuthGuard],
        data: { module: 'invoices', permission: 'get-all', view: 'central' },
      },
      {
        //* La CARTERA es del módulo `wallet`. Leerla exige `get-all`; cerrarla y reabrirla exigen
        //* `settings`, y eso lo comprueba el backend — aquí solo se decide quién ve la pantalla.
        path: 'cartera',
        component: CarteraComponent,
        canActivate: [AuthGuard],
        data: { module: 'wallet', permission: 'get-all', view: 'cartera' },
      },
      {
        //* El avance es una cifra AGREGADA de toda la arrendadora: `view` y no `get-all`, igual que el
        //* embudo. `payments:get-all` lo tienen Client, Legal y Seller; `view`, solo quien concilia.
        path: 'avance',
        component: AvanceComponent,
        canActivate: [AuthGuard],
        data: { module: 'payments', permission: 'view', view: 'avance' },
      },
      {
        //! `reconcile` y NUNCA `get-all`: la conciliación expone CLABEs de clientes, y
        //! `payments:get-all` lo tienen Client (el rol de la app móvil), Legal y Seller. Tampoco
        //! `adjust`, que es la cirugía de pagos: Contabilidad concilia pero no opera sobre el dinero.
        //! Es el mismo par que gatea el endpoint, para que la pantalla no aparezca en un menú que
        //! después devuelve 403.
        path: 'conciliacion',
        component: ConciliacionComponent,
        canActivate: [AuthGuard],
        data: { module: 'payments', permission: 'reconcile', view: 'conciliacion' },
      },
      { path: 'lote', canActivate: [AuthGuard, abrirCargaDePagos], data: { module: 'payments', permission: 'create' }, children: [] },
      { path: 'lote/:uploadBatch', canActivate: [AuthGuard, abrirCargaDePagos], data: { module: 'payments', permission: 'create' }, children: [] },
    ],
  },
  /**
   * Comités (F-143): el hub del Comité de Aprobaciones, con el molde de Cobranza. El padre pone el
   * cascarón SIN guard; cada hija lleva `canActivate` y su `data` COMPLETO (`module`, `permission`,
   * `view`, `group`): con la estrategia por defecto un hijo con path no vacío no hereda nada, y
   * `AuthGuard` deja pasar cuando le faltan `module` o `permission`.
   *
   * Todas con `committee.view` (Admin, Legal, Operaciones y Finanzas): la diferencia entre roles
   * está en las acciones —votar, cerrar, crear—, no en qué pestaña pueden mirar (D-7). `sesion/:id`
   * exige `get-by-id`, el mismo par que su endpoint: es el destino del botón del correo.
   */
  {
    path: 'comites',
    component: CommitteesPageComponent,
    data: { module: 'committee', permission: 'view' },
    children: [
      { path: '', redirectTo: 'sesiones', pathMatch: 'full' },
      {
        path: 'sesiones',
        component: SessionsListComponent,
        canActivate: [AuthGuard],
        data: { module: 'committee', permission: 'view', view: 'sesiones' },
      },
      {
        path: 'por-originar',
        component: CommitteeLeasesComponent,
        canActivate: [AuthGuard],
        data: { module: 'committee', permission: 'view', view: 'por-originar', group: 'originating' },
      },
      {
        path: 'activos',
        component: CommitteeLeasesComponent,
        canActivate: [AuthGuard],
        data: { module: 'committee', permission: 'view', view: 'activos', group: 'active' },
      },
      {
        path: 'cerrados',
        component: CommitteeLeasesComponent,
        canActivate: [AuthGuard],
        data: { module: 'committee', permission: 'view', view: 'cerrados', group: 'closed' },
      },
      {
        path: 'sesion/:id',
        component: SessionDetailComponent,
        canActivate: [AuthGuard],
        data: { module: 'committee', permission: 'get-by-id', view: 'sesion' },
      },
    ],
  },
  /**
   * Plan v4.2 §9.1 · Bandeja de validaciones del formato de buró. `credit-history.view-validations`: Legal la atiende
   * y Admin la ve en solo lectura (aprobar exige `validate`, que solo tiene Legal; lo decide la pantalla y la API).
   */
  {
    path: 'credit-history/validations',
    component: CreditValidationsListComponent,
    canActivate: [AuthGuard],
    data: { module: 'credit-history', permission: 'view-validations' },
  },
  {
    path: 'credit-history/validations/:id',
    component: CreditValidationDetailComponent,
    canActivate: [AuthGuard],
    data: { module: 'credit-history', permission: 'view-validations' },
  },
  /**
   * Plan v4.3 §9.3 · Bandeja «Preofertas por autorizar»: `lease-preoffer.view-reviews`. Legal autoriza o regresa; Admin
   * la ve en solo lectura (decidir exige `review`, que solo tiene Legal; lo decide la pantalla y la API).
   */
  {
    path: 'preofertas/legal',
    component: PreofferReviewsListComponent,
    canActivate: [AuthGuard],
    data: { module: 'lease-preoffer', permission: 'view-reviews' },
  },
  {
    path: 'preofertas/legal/:id',
    component: PreofferReviewDetailComponent,
    canActivate: [AuthGuard],
    data: { module: 'lease-preoffer', permission: 'view-reviews' },
  },
  //* Plan v4.3 §9.4 · Configuración de la preoferta: Admin y Finanzas. Guardar umbrales pide `update`; el modo, `activate`.
  {
    path: 'preofertas/configuracion',
    component: PreofferSettingsComponent,
    canActivate: [AuthGuard],
    data: { module: 'lease-preoffer-settings', permission: 'view' },
  },
  //* Las puertas viejas sobreviven como REDIRECCIONES y no como pantallas gemelas: un marcador
  //* guardado sigue funcionando y el menú ya no puede desincronizarse de lo que se ve.
  { path: 'payment', redirectTo: 'cobranza/dinero', pathMatch: 'full' },
  { path: 'invoices', redirectTo: 'cobranza/comprobantes', pathMatch: 'full' },
  //* Aplicaciones se retira (D-04): su único aporte —el desglose por concepto— vive en el cajón del
  //* pago, y ahí está en contexto en vez de en una tabla sin dueño.
  { path: 'application', redirectTo: 'cobranza/dinero', pathMatch: 'full' },
  { path: 'pagos/lote', redirectTo: 'cobranza/lote', pathMatch: 'full' },
  { path: 'pagos/lote/:uploadBatch', redirectTo: 'cobranza/lote/:uploadBatch' },
  //* La pantalla independiente de Exigibilidad se retiró: vive dentro del arrendamiento (F10).
  //* Las dos redirecciones evitan que un enlace guardado aterrice en un 404.
  { path: 'enforceability', redirectTo: 'lease', pathMatch: 'full' },
  { path: 'enforceability/:id', redirectTo: 'lease/:id' },
  {
    path: 'admin',
    data: { module: 'users', permission: 'view' },
    children: [
      {
        //* Consola de Administradores (lista Admins + Roles): gateada por `roles.view`,
        //* que SOLO tiene Admin. Antes usaba `users.view`, que también tienen Legal y
        //* MasterBroker → entraban por URL y cosechaban 403 de POST /roles. La subruta
        //* /admin/reports conserva su propio gate (`reports.view`).
        path: '',
        component: AdminListComponent,
        canActivate: [AuthGuard],
        data: { module: 'roles', permission: 'view' },
      },
      {
        //* `reports.view` y no `create`: la pantalla ya no genera nada — es el catálogo y el
        //* historial. Contabilidad, que es quien vive en estos reportes, tiene `view` y no `create`.
        path: 'reports',
        component: ReporteriaComponent,
        canActivate: [AuthGuard],
        data: { module: 'reports', permission: 'view' },
      },
    ],
  },
  {
    path: 'wallet',
    data: { module: 'wallet', permission: 'view' },
    children: [
      {
        path: '',
        component: WalletListComponent,
        canActivate: [AuthGuard],
        data: { module: 'wallet', permission: 'view' },
      },
      {
        path: 'admin-details',
        component: AdminDetailsComponent,
        canActivate: [AuthGuard],
        data: { module: 'wallet', permission: 'admin' },
      },
      {
        path: ':id',
        component: WalletsDetailComponent,
        canActivate: [AuthGuard],
        data: { module: 'wallet', permission: 'get-by-id' },
      },
    ],
  },
  {
    path: 'algorithm-config',
    data: { module: 'algorithm-config', permission: 'view' },
    children: [
      {
        path: '',
        component: AlgorithmConfigListComponent,
        canActivate: [AuthGuard],
        data: { module: 'algorithm-config', permission: 'view' },
      },
      {
        //! 'new' va ANTES de ':id' o la ruta paramétrica lo captura como un id y el detalle
        //! intenta cargar una configuración llamada "new".
        path: 'new',
        component: AlgorithmConfigDetailComponent,
        canActivate: [AuthGuard],
        data: { module: 'algorithm-config', permission: 'create' },
      },
      {
        path: ':id',
        component: AlgorithmConfigDetailComponent,
        canActivate: [AuthGuard],
        data: { module: 'algorithm-config', permission: 'view' },
      },
    ],
  },
  /**
   * Plan v4.2 §7.2 · Configuración de la calculadora de riesgo: Admin y Finanzas (D-17). Como en el Algoritmo de
   * ofertas, cada hija repite su `data`; `new` va antes de `:id`.
   */
  {
    path: 'risk-scorecard-config',
    data: { module: 'risk-scorecard-config', permission: 'view' },
    children: [
      {
        path: '',
        component: RiskScorecardConfigListComponent,
        canActivate: [AuthGuard],
        data: { module: 'risk-scorecard-config', permission: 'get-all' },
      },
      {
        path: 'new',
        component: RiskScorecardConfigDetailComponent,
        canActivate: [AuthGuard],
        data: { module: 'risk-scorecard-config', permission: 'create' },
      },
      {
        path: ':id',
        component: RiskScorecardConfigDetailComponent,
        canActivate: [AuthGuard],
        data: { module: 'risk-scorecard-config', permission: 'get-by-id' },
      },
    ],
  },
  {
    /**
     * Las reglas de vencimiento de las facturas viven aparte de `/wallet-config` a propósito.
     *
     *! Contabilidad tiene `invoices: get-all/update` y de `wallet-config` solo `get-all`, sin `view`:
     *! no puede ni entrar a esa pantalla. Meter ahí estas reglas habría obligado a darles
     *! `wallet-config.view`, que además abre la tasa de mora y la generación de cortes — una
     *! ampliación de permisos para administrar lo que justamente es suyo.
     */
    path: 'invoice-rules',
    component: InvoiceRulesListComponent,
    canActivate: [AuthGuard],
    data: { module: 'invoices', permission: 'get-all' },
  },
  {
    path: 'wallet-config',
    data: { module: 'wallet-config', permission: 'view' },
    children: [
      {
        path: '',
        component: WalletConfigListComponent,
        canActivate: [AuthGuard],
        data: { module: 'wallet-config', permission: 'view' },
      },
      {
        path: ':id',
        component: WalletConfigDetailComponent,
        canActivate: [AuthGuard],
        data: { module: 'wallet-config', permission: 'view' },
      },
    ],
  },
  {
    path: 'dripping',
    data: { module: 'dripping', permission: 'view' },
    children: [
      // Templates
      {
        path: 'templates',
        component: TemplatesListComponent,
        canActivate: [AuthGuard],
        data: { module: 'dripping', permission: 'view' },
      },
      {
        path: 'templates/:id',
        component: TemplateDetailComponent,
        canActivate: [AuthGuard],
        data: { module: 'dripping', permission: 'get-by-id' },
      },

      // Strategies
      {
        path: 'strategies',
        component: StrategiesListComponent,
        canActivate: [AuthGuard],
        data: { module: 'dripping', permission: 'view' },
      },
      {
        path: 'strategies/new',
        component: StrategyWizardComponent,
        canActivate: [AuthGuard],
        data: { module: 'dripping', permission: 'create' },
      },
      {
        path: 'strategies/:id/edit',
        component: StrategyWizardComponent,
        canActivate: [AuthGuard],
        data: { module: 'dripping', permission: 'update' },
      },
      {
        path: 'strategies/:id',
        component: StrategyDetailComponent,
        canActivate: [AuthGuard],
        data: { module: 'dripping', permission: 'get-by-id' },
      },

      // Campaigns
      {
        path: 'campaigns',
        component: CampaignsListComponent,
        canActivate: [AuthGuard],
        data: { module: 'dripping', permission: 'view' },
      },
      {
        path: 'campaigns/:id',
        component: CampaignDetailComponent,
        canActivate: [AuthGuard],
        data: { module: 'dripping', permission: 'get-by-id' },
      },

      // Communications
      {
        path: 'communications',
        component: CommunicationsListComponent,
        canActivate: [AuthGuard],
        data: { module: 'dripping', permission: 'view' },
      },

      // Redirect default to templates
      {
        path: '',
        redirectTo: 'templates',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'provider',
    data: { module: 'providers', permission: 'view' },
    children: [
      {
        path: '',
        component: ProviderListComponent,
        canActivate: [AuthGuard],
        data: { module: 'providers', permission: 'view' },
      },
      {
        path: ':id',
        component: ProviderDetailComponent,
        canActivate: [AuthGuard],
        data: { module: 'providers', permission: 'get-by-id' },
      },
    ],
  },
  {
    // Documentación interna. Un manual por ruta; el catálogo
    // (`documentation-catalog.constant.ts`) es la fuente de los slugs válidos y también
    // alimenta los items del sidebar, así que ruta y menú no se desincronizan.
    path: 'documentation',
    data: { module: 'documentation', permission: 'view' },
    children: [
      {
        path: '',
        redirectTo: DOCUMENTATION_MENU[0].slug,
        pathMatch: 'full',
      },
      {
        // ANTES de `:slug`: si no, 'avance' se leería como el slug de un manual y rebotaría.
        path: 'avance',
        component: DocumentationProgressComponent,
        canActivate: [AuthGuard],
        data: { module: 'documentation', permission: 'view' },
      },
      {
        path: ':slug',
        component: DocumentationViewerComponent,
        canActivate: [AuthGuard],
        data: { module: 'documentation', permission: 'view' },
      },
    ],
  },
  {
    // Roadmap interno. Gated por `roadmap.view`; dentro, los tabs de Métricas y Visión
    // son Admin-only. Todo se alimenta del módulo `worklog` de la API (ADR-0040).
    path: 'roadmap',
    data: { module: 'roadmap', permission: 'view' },
    children: [
      {
        path: '',
        component: RoadmapPageComponent,
        canActivate: [AuthGuard],
        data: { module: 'roadmap', permission: 'view' },
      },
      {
        // Ficha visual de un proyecto. Es la primera ruta profunda del roadmap: el resto son tabs
        // en memoria, así que hasta ahora no había forma de mandarle a nadie un enlace a esto.
        // El gate de Admin va DENTRO del componente, como en la pestaña Proyectos: el permiso de
        // ruta es `roadmap.view` y lo que separa a Admin es un rol, no un permiso.
        path: 'proyecto/:slug',
        component: RoadmapProjectShowcaseComponent,
        canActivate: [AuthGuard],
        data: { module: 'roadmap', permission: 'view' },
      },
    ],
  },
  {
    path: 'omnichannel',
    data: { module: 'omnichannel', permission: 'create' },
    children: [
      {
        path: '',
        component: OmnichannelAdminComponent,
        canActivate: [AuthGuard],
        data: { module: 'omnichannel', permission: 'create' },
      },
      {
        path: 'metrics',
        component: OmnichannelMetricsComponent,
        canActivate: [AuthGuard],
        data: { module: 'omnichannel', permission: 'view' },
      },
    ],
  },
  {
    path: 'funnel-tasks',
    data: { module: 'activities', permission: 'view' },
    children: [
      {
        path: '',
        component: FunnelTasksComponent,
        canActivate: [AuthGuard],
        data: { module: 'activities', permission: 'view' },
      },
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [NoAuthGuard],
  },
  {
    // ADR-0014: cambio obligatorio de contraseña en primer ingreso. Requiere sesión
    // (AuthGuard) pero queda exenta del redirect de mustChangePassword para no entrar
    // en bucle. Sin `module`/`permission` → el AuthGuard permite el acceso.
    path: 'change-password',
    component: ChangePasswordComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'quoter',
    component: QuoterComponent,
    canActivate: [NoAuthGuard],
  },
  {
    path: 'logout',
    component: LogoutComponent,
    canActivate: [AuthGuard],
  },
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
